<script setup>
import {v4 as uuidv4} from "uuid"
import {computed, ref} from "vue"

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: 'payment_method'
    },
    secondaryLabel: {
      type: String,
      default: null,
    },
    modelValue: {
        type: [Number, String],
        default: ""
    },
    value: {
        type: [Number, String],
        default: ""
    },
    disabled: {
        type: Boolean,
        default: false
    },
    hideBottomBorder: {
      type: Boolean,
      default: false
    }
})

const inputLabel = ref(null)

const inputValue = computed( {
    get() {
        return props.modelValue
    },
    set(newValue) {
        emits('update:modelValue', newValue)
    }
})

const emits = defineEmits(["update:modelValue"])

const id = computed(() => `radio-${uuidv4()}`)

</script>

<template>
  <div class="step-payment-method__radio custom-radio-wrapper cursor-auto">
    <div>
      <div class="custom-radio custom-radio--medium">
        <input
          v-model="inputValue"
          :value="value"
          type="radio"
          :id="id"
          :disabled="disabled"
          class="custom-radio__input"
          :name="name"
        >
        <span class="custom-radio__indicator"></span>
      </div>
    </div>
    <div :class="{'input-group__label-wrapper label-content-offset': true, 'hide-bottom-border': hideBottomBorder}" >
      <div v-if="secondaryLabel" class="secondary-label-wrapper full-width">
          <label class="custom-radio__label full-width" :for="id" ref="inputLabel">
            {{ label }} <span>{{ `(${secondaryLabel})` }}</span>
          </label>
          <span>{{ $t('free') }}</span>
      </div>

      <div v-else class="secondary-label-wrapper full-width">
        <label class="custom-radio__label full-width" :for="id" ref="inputLabel">
          {{ label }}
          <template v-if="$slots.secondaryLabel">
            <span><slot name="secondaryLabel" /></span>
          </template>
        </label>
        <template v-if="$slots.rightLabel">
          <span><slot name="rightLabel" /></span>
        </template>
      </div>

      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .label-content-offset {
    padding-top: 2.4px;
  }

  .hide-bottom-border {
    border: none !important;
  }

  .secondary-label-wrapper {
    display: flex;
    justify-content: space-between;
  }
</style>
